import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCamera = props => (
  <SvgIcon {...props} viewBox="0 0 48.101799 43.826099">
    <path d="m30.999 24.051c0 4.632-2.3161 6.948-6.9481 6.948s-6.948-2.316-6.948-6.948 2.316-6.9481 6.948-6.9481 6.9481 2.3161 6.9481 6.9481zm-14.163-24.051l-4.4013 4.8696h-7.6241c-2.6464 0-4.811 2.1913-4.811 4.8695v29.217c0 2.6783 2.1646 4.8696 4.8102 4.8696h38.481c2.6456 0 4.8102-2.1913 4.8102-4.8696v-29.217c0-2.6783-2.1646-4.8696-4.8102-4.8696h-7.6241l-4.401-4.8694h-14.43zm7.2153 35.275c-6.1955 0-11.224-5.0283-11.224-11.224 0-6.1955 5.0283-11.224 11.224-11.224 6.1955 0 11.224 5.0283 11.224 11.224 0 6.1955-5.0283 11.224-11.224 11.224z" />
  </SvgIcon>
);

export default IconCamera;



// WEBPACK FOOTER //
// ./src/components/icons/IconCamera.js